import { render } from "./SexyYearlyCosts.vue?vue&type=template&id=0da444da"
import script from "./SexyYearlyCosts.vue?vue&type=script&lang=js"
export * from "./SexyYearlyCosts.vue?vue&type=script&lang=js"

import "./SexyYearlyCosts.vue?vue&type=style&index=0&id=0da444da&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__